import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "d-flex mobile-column" }
const _hoisted_3 = { class: "left pe-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-9" }, "Kim Petras", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, " Bring your VIP laminate to life with YOUR video from the show or meet and greet! No fees or subscription required. ", -1)
const _hoisted_7 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden my-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "15",
  viewBox: "0 0 26 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.6484 5.58594C24.7526 5.5599 24.8438 5.58594 24.9219 5.66406C25 5.71615 25.0391 5.82031 25.0391 5.97656V6.64062C25.0391 6.79688 24.9609 6.90104 24.8047 6.95312C23.7109 7.21354 22.3828 7.82552 20.8203 8.78906C20.0651 9.28385 19.5573 9.58333 19.2969 9.6875C17.6302 10.5208 16.3672 10.9375 15.5078 10.9375C14.5703 10.9375 13.8542 10.651 13.3594 10.0781C12.8385 9.42708 12.6172 8.39844 12.6953 6.99219L12.8125 5.89844C12.8125 5.82031 12.7734 5.76823 12.6953 5.74219C12.6172 5.6901 12.5391 5.6901 12.4609 5.74219L11.6797 6.40625C9.67448 8.125 6.86198 10.9245 3.24219 14.8047C3.11198 14.9349 2.94271 15 2.73438 15C2.52604 14.974 2.36979 14.8828 2.26562 14.7266C2.13542 14.5182 2.10938 14.2969 2.1875 14.0625L6.09375 3.59375C6.35417 2.86458 6.21094 2.2526 5.66406 1.75781C5.3776 1.4974 5.05208 1.36719 4.6875 1.36719C4.375 1.36719 4.10156 1.45833 3.86719 1.64062L0.898438 3.63281C0.690104 3.76302 0.533854 3.73698 0.429688 3.55469L0.078125 2.89062C-0.0260417 2.73438 0.0130208 2.60417 0.195312 2.5L3.04688 0.546875C3.77604 0.130208 4.41406 -0.0390625 4.96094 0.0390625C5.53385 0.0911458 6.02865 0.3125 6.44531 0.703125C6.9401 1.11979 7.2526 1.64062 7.38281 2.26562C7.53906 2.89062 7.5 3.5026 7.26562 4.10156L4.53125 11.4453L6.67969 9.25781C9.96094 5.8724 12.0703 4.14062 13.0078 4.0625C13.3203 4.0625 13.5547 4.15365 13.7109 4.33594C14.0495 4.72656 14.1536 5.46875 14.0234 6.5625C13.8672 7.78646 13.9714 8.60677 14.3359 9.02344C14.5964 9.36198 14.987 9.53125 15.5078 9.53125C16.1849 9.53125 17.2786 9.16667 18.7891 8.4375C19.0755 8.28125 19.6094 7.96875 20.3906 7.5C22.0833 6.51042 23.5026 5.8724 24.6484 5.58594Z",
    fill: "#4A4A4A"
  })
], -1)
const _hoisted_9 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden my-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "26",
  height: "15",
  viewBox: "0 0 26 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24.6484 5.58594C24.7526 5.5599 24.8438 5.58594 24.9219 5.66406C25 5.71615 25.0391 5.82031 25.0391 5.97656V6.64062C25.0391 6.79688 24.9609 6.90104 24.8047 6.95312C23.7109 7.21354 22.3828 7.82552 20.8203 8.78906C20.0651 9.28385 19.5573 9.58333 19.2969 9.6875C17.6302 10.5208 16.3672 10.9375 15.5078 10.9375C14.5703 10.9375 13.8542 10.651 13.3594 10.0781C12.8385 9.42708 12.6172 8.39844 12.6953 6.99219L12.8125 5.89844C12.8125 5.82031 12.7734 5.76823 12.6953 5.74219C12.6172 5.6901 12.5391 5.6901 12.4609 5.74219L11.6797 6.40625C9.67448 8.125 6.86198 10.9245 3.24219 14.8047C3.11198 14.9349 2.94271 15 2.73438 15C2.52604 14.974 2.36979 14.8828 2.26562 14.7266C2.13542 14.5182 2.10938 14.2969 2.1875 14.0625L6.09375 3.59375C6.35417 2.86458 6.21094 2.2526 5.66406 1.75781C5.3776 1.4974 5.05208 1.36719 4.6875 1.36719C4.375 1.36719 4.10156 1.45833 3.86719 1.64062L0.898438 3.63281C0.690104 3.76302 0.533854 3.73698 0.429688 3.55469L0.078125 2.89062C-0.0260417 2.73438 0.0130208 2.60417 0.195312 2.5L3.04688 0.546875C3.77604 0.130208 4.41406 -0.0390625 4.96094 0.0390625C5.53385 0.0911458 6.02865 0.3125 6.44531 0.703125C6.9401 1.11979 7.2526 1.64062 7.38281 2.26562C7.53906 2.89062 7.5 3.5026 7.26562 4.10156L4.53125 11.4453L6.67969 9.25781C9.96094 5.8724 12.0703 4.14062 13.0078 4.0625C13.3203 4.0625 13.5547 4.15365 13.7109 4.33594C14.0495 4.72656 14.1536 5.46875 14.0234 6.5625C13.8672 7.78646 13.9714 8.60677 14.3359 9.02344C14.5964 9.36198 14.987 9.53125 15.5078 9.53125C16.1849 9.53125 17.2786 9.16667 18.7891 8.4375C19.0755 8.28125 19.6094 7.96875 20.3906 7.5C22.0833 6.51042 23.5026 5.8724 24.6484 5.58594Z",
    fill: "#4A4A4A"
  })
], -1)
const _hoisted_11 = { class: "input-group border border-dark align-items-center p-2 rounded overflow-hidden my-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "15",
  viewBox: "0 0 20 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.125 0C18.6458 0 19.0885 0.182292 19.4531 0.546875C19.8177 0.911458 20 1.35417 20 1.875V13.125C20 13.6458 19.8177 14.0885 19.4531 14.4531C19.0885 14.8177 18.6458 15 18.125 15H1.875C1.35417 15 0.911458 14.8177 0.546875 14.4531C0.182292 14.0885 0 13.6458 0 13.125V1.875C0 1.35417 0.182292 0.911458 0.546875 0.546875C0.911458 0.182292 1.35417 0 1.875 0H18.125ZM1.875 1.25C1.69271 1.25 1.53646 1.3151 1.40625 1.44531C1.30208 1.54948 1.25 1.69271 1.25 1.875V3.47656C2.16146 4.25781 4.1276 5.84635 7.14844 8.24219C7.14844 8.24219 7.33073 8.39844 7.69531 8.71094C8.0599 8.9974 8.33333 9.20573 8.51562 9.33594C8.69792 9.46615 8.93229 9.60938 9.21875 9.76562C9.53125 9.92188 9.79167 10 10 10C10.1823 10 10.3776 9.96094 10.5859 9.88281C10.7943 9.80469 11.0026 9.6875 11.2109 9.53125C11.4453 9.375 11.6406 9.23177 11.7969 9.10156C11.9792 8.97135 12.1875 8.8151 12.4219 8.63281C12.6562 8.42448 12.7995 8.29427 12.8516 8.24219C15.8724 5.84635 17.8385 4.25781 18.75 3.47656V1.875C18.75 1.69271 18.6849 1.54948 18.5547 1.44531C18.4505 1.3151 18.3073 1.25 18.125 1.25H1.875ZM18.125 13.75C18.3073 13.75 18.4505 13.6979 18.5547 13.5938C18.6849 13.4635 18.75 13.3073 18.75 13.125V5.11719C17.8385 5.84635 16.1328 7.21354 13.6328 9.21875C13.5807 9.24479 13.3984 9.38802 13.0859 9.64844C12.7995 9.90885 12.5651 10.1042 12.3828 10.2344C12.2005 10.3646 11.9661 10.5208 11.6797 10.7031C11.3932 10.8854 11.1068 11.0286 10.8203 11.1328C10.5339 11.2109 10.2604 11.25 10 11.25C9.76562 11.25 9.51823 11.2109 9.25781 11.1328C9.02344 11.0547 8.80208 10.9635 8.59375 10.8594C8.41146 10.7552 8.1901 10.625 7.92969 10.4688C7.69531 10.2865 7.5 10.1432 7.34375 10.0391C7.1875 9.90885 7.00521 9.7526 6.79688 9.57031C6.58854 9.38802 6.44531 9.27083 6.36719 9.21875C3.86719 7.21354 2.16146 5.84635 1.25 5.11719V13.125C1.25 13.3073 1.30208 13.4635 1.40625 13.5938C1.53646 13.6979 1.69271 13.75 1.875 13.75H18.125Z",
    fill: "#4A4A4A"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fs-14" }, " You will receive a unique access code at the end of this form which will allow you to view YOUR video in augmented reality on your laminate ", -1)
const _hoisted_15 = { class: "d-flex align-items-start mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "ch1",
  class: "mb-0 fs-14 text-muted ms-2"
}, " I want my video to be considered for use on social media or displayed within edited footage. ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fs-14 text-muted mt-5" }, " By proceeding , I confirm I am uploading a video that I own, have permission to use and/or was taken on my mobile device. My video is also in compliance with the terms of use. ", -1)
const _hoisted_18 = { class: "text-center mt-5" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card border-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/img.png",
      class: "img-fluid card-img-top",
      alt: ""
    })
  ])
], -1)

import {Field, ErrorMessage} from "vee-validate";
import {useRouter} from "vue-router";
import {useForm} from "vee-validate";
import * as Yup from "yup";
import axios from "axios";
import {apiHost} from "@/data/constants";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Page1',
  setup(__props) {

const router = useRouter();
const {values, handleSubmit} = useForm({
  validationSchema: Yup.object().shape({
    last_name: Yup.string().required("Last Name is a required field"),
    first_name: Yup.string().required("First Name is a required field"),
    email: Yup.string().required("Email is a required field"),
  })
})

const submitButtonDisabled = ref(false)
const onFormSubmit = handleSubmit(async (values) => {
  try {
    submitButtonDisabled.value = true;
    // const response = await axios.post(`${apiHost}/kimp/send_email_verification_code`, values)
    await router.push({name: "page2", query: values})

  } catch (e) {
    alert('Error')
  } finally {
    submitButtonDisabled.value = false;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onFormSubmit) && _unref(onFormSubmit)(...args)), ["prevent"])),
            action: ""
          }, [
            _createVNode(_unref(Field), { name: "first_name" }, {
              default: _withCtx(({field}) => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("input", _mergeProps(field, {
                    type: "text",
                    class: "form-control border-0",
                    placeholder: "First Name *"
                  }), null, 16)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(ErrorMessage), {
              name: "first_name",
              class: "fv-plugins-message-container text-danger"
            }),
            _createVNode(_unref(Field), { name: "last_name" }, {
              default: _withCtx(({field}) => [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("input", _mergeProps(field, {
                    type: "text",
                    class: "form-control border-0",
                    placeholder: "Last Name *"
                  }), null, 16)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(ErrorMessage), {
              name: "last_name",
              class: "fv-plugins-message-container text-danger"
            }),
            _createVNode(_unref(Field), { name: "email" }, {
              default: _withCtx(({field}) => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("input", _mergeProps(field, {
                    type: "text",
                    class: "form-control border-0",
                    placeholder: "Email Address"
                  }), null, 16)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(ErrorMessage), {
              name: "email",
              class: "fv-plugins-message-container text-danger"
            }),
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(Field), {
                type: "checkbox",
                name: "agree",
                class: "mt-1",
                value: true,
                "unchecked-value": false
              }),
              _hoisted_16
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                disabled: submitButtonDisabled.value,
                class: "btn btn-dark py-2 px-5 rounded-0"
              }, _toDisplayString(submitButtonDisabled.value ? "Please wait..." : "NEXT"), 9, _hoisted_19)
            ])
          ], 32)
        ]),
        _hoisted_20
      ])
    ])
  ]))
}
}

})